import { render, staticRenderFns } from "./WolfYears.vue?vue&type=template&id=cd45c1c6&scoped=true&"
import script from "./WolfYears.vue?vue&type=script&lang=js&"
export * from "./WolfYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd45c1c6",
  null
  
)

export default component.exports